import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSWholeWheatBagelsProduct from 'models/BSWholeWheatBagelsProduct'
import BSWholeWheatBagelsPackage from './BSWholeWheatBagelsPackage'

const productOptions = {
  packagingInfo: <BSWholeWheatBagelsPackage />,
  productTitle: 'Brand Specific Whole Wheat Bagels',
  model: BSWholeWheatBagelsProduct,
  validCategories: ['16'],
  validSubCategories: ['010BS'],
  brandSpecific: true,
}

const BSWholeWheatBagels = () => <ProductForm product={productOptions} />

export default BSWholeWheatBagels
